import { render, staticRenderFns } from "./cart-costs.vue?vue&type=template&id=dcb8335e&scoped=true&lang=pug&"
import script from "./cart-costs.vue?vue&type=script&lang=coffee&"
export * from "./cart-costs.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb8335e",
  null
  
)

export default component.exports